import { Link } from "react-router-dom";
import { textChooser } from "../../util/textChooser";
import successImg from "../../../assets/images/success.png";
import "./postulation.style.scss";
import { Icon } from "../icons";

export default function OpportunityClosed() {
  return (
    <div className="postulation-container">
      <span style={{zoom: "2"}}>
          <Icon type="deleted"/>
      </span>
      <h2 style={{marginTop: 20}}>Postulación Cerrada.</h2>
      <p style={{textAlign: "center"}}>
        Gracias por tu interes pero lastimosamente esta postulación ha sido cerrada o eliminada.
      </p>
    </div>
  );
}